import React, { Component } from 'react';
import BlazePager from 'components/ui/pagination/BlazePager';
import BlazeExpandButton from 'components/ui/BlazeExpandButton';
import { BlazeTableColDef, BlazeTableOptions } from 'components/blazeTable/BlazeTable.types';
import BlazeTable from 'components/blazeTable/BlazeTable';
import { Response } from 'store/marFiles/marFilesTypes';
import 'views/AssetCatalog/MarFiles/MarsTable/MarFileAssetView/MarFileAssetView.css';
import i18n from 'i18n';
import clsx from 'clsx';
import _ from 'lodash';
import NoContentPlaceholder from 'components/ui/noContentPlaceholder/NoContentPlaceholder';

type MarFileAssetViewResponseTabProps = {
  responseData: Response[];
};

const colsDefinition: BlazeTableColDef[] = [
  {
    header: i18n.t('marFiles:detailedMeta.tableHeader.name'),
    accessor: 'name',
  },
  {
    header: i18n.t('marFiles:detailedMeta.tableHeader.value'),
    accessor: 'value',
  },
];

const requestTblOpts: BlazeTableOptions = {
  columnDef: colsDefinition,
  pageable: false,
  selectable: false,
  isRowExpandable: () => false,
  showRowExpander: false,
  tableName: 'requestTable',
  customRowClassName: 'bg-white h-20 flex-table-row',
  customHeaderClassName: 'flex-table-item-top',
  customTableClassName: 'flex-table-simple',
};

interface LocalState {
  activePage: number;
  pageCount: number;
  isAreaExpanded: boolean;
  tableViewActive: boolean;
}

class MarFileAssetViewResponseTab extends Component<MarFileAssetViewResponseTabProps, LocalState> {
  componentDidMount(): void {
    this.setState({
      pageCount: this.props.responseData.length,
    });
  }

  state = {
    activePage: 1,
    pageCount: 0,
    isAreaExpanded: false,
    tableViewActive: true,
  };

  isAreaExpandedChanged = () => {
    const newVal = !this.state.isAreaExpanded;
    this.setState({
      isAreaExpanded: newVal,
    });
  };

  pageSelectedHandler = (activePage: number) => {
    this.setState({
      activePage: activePage,
    });
  };

  toggleHeadersView = (tableViewActive: boolean) => {
    this.setState({
      tableViewActive: tableViewActive,
    });
  };

  render() {
    const { activePage, pageCount, isAreaExpanded } = this.state;
    const activeIndex = activePage - 1;
    const { responseData } = this.props;
    const cardClassName = isAreaExpanded ? 'expanded-card-area' : '';
    const expandButtonText = isAreaExpanded
      ? i18n.t('marFiles:detailedMeta.showLess')
      : i18n.t('marFiles:detailedMeta.showMore');

    let tableData: any[] = [];
    if (!_.isEmpty(responseData) && responseData[activeIndex] !== null && responseData[activeIndex].metaData !== null) {
      tableData = responseData[activeIndex].metaData!.map((meta, index) => {
        return {
          id: index,
          name: meta.name,
          value: meta.value,
        };
      });
    }

    let bodyContent = '';
    if (!_.isEmpty(responseData) && responseData[activeIndex] !== null && responseData[activeIndex].body !== null) {
      if (!responseData[activeIndex].body!.binary) {
        bodyContent = Buffer.from(responseData[activeIndex].body!.body, 'base64').toString();
      } else {
        bodyContent = i18n.t('marFiles:detailedMeta.responseData.binaryResponseBody');
      }
    }

    let cardContent;

    if (this.state.tableViewActive) {
      cardContent = <BlazeTable options={requestTblOpts} data={tableData} />;
    } else {
      cardContent = (
        <div>
          {tableData.map((item: any) => (
            <div className="mr-4" key={item.name + '-' + item.value}>
              {item.name}: {item.value}
            </div>
          ))}
        </div>
      );
    }

    return (
      <React.Fragment>
        <div className="p-4">
          {pageCount > 1 && (
            <div className="pb-4 clearfix">
              <span className="float-right">
                <BlazePager total={pageCount} activePage={activePage} pageSelectedHandler={this.pageSelectedHandler} />
              </span>
            </div>
          )}
          <div className="card-deck mb-4">
            <div className="card">
              <div className="card-header">
                <div className="btn-group float-right" role="group">
                  <button
                    type="button"
                    className={clsx('btn btn-secondary', this.state.tableViewActive && 'active')}
                    onClick={() => this.toggleHeadersView(true)}
                  >
                    {i18n.t('marFiles:detailedMeta.responseData.switcher.table')}
                  </button>
                  <button
                    type="button"
                    className={clsx('btn btn-secondary', !this.state.tableViewActive && 'active')}
                    onClick={() => this.toggleHeadersView(false)}
                  >
                    {i18n.t('marFiles:detailedMeta.responseData.switcher.text')}
                  </button>
                </div>
                <h2 className="card-title mt-2">{i18n.t('marFiles:detailedMeta.responseData.headers')}</h2>
              </div>

              <div className="card-body">
                <div className={'card-text card-content ' + cardClassName} style={{ overflow: 'auto' }}>
                  {cardContent}
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header">
                <h2 className="card-title mt-2 mb-1">{i18n.t('marFiles:detailedMeta.requestData.body')}</h2>
              </div>
              <div className="card-body">
                <div className={'card-text card-content ' + cardClassName} style={{ overflow: 'auto' }}>
                  {!!bodyContent.length && <div className="content-text-area">{bodyContent}</div>}
                  {!bodyContent.length && (
                    <NoContentPlaceholder
                      placeHolderContent={i18n.t('marFiles:detailedMeta.responseData.noResponseText')}
                      height={isAreaExpanded ? 560 : 260}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="expand-button-container">
            <BlazeExpandButton
              buttonClass={'btn btn-secondary btn-rounded'}
              buttonText={expandButtonText}
              isTextAreaExpanded={isAreaExpanded}
              fnCallback={this.isAreaExpandedChanged}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default MarFileAssetViewResponseTab;
